import { useState } from "react";
import { useParams } from 'react-router';
import Helper from "../helper";
import Auth from "../services/auth.service";

const ApplicationToken = () => {
    const { token } = useParams();

    const checkToken = () => {
        window.localStorage.clear();

        var formData = new FormData;
        formData.append('token', token);

        Auth.verify(formData).then((response) => {
            var res = response.data;

            if (res.success == true) {
                localStorage.setItem('user', JSON.stringify(res.data));
                Helper.success(res.message);
                setTimeout(() => {
                    window.location.href = '/stepform'
                }, 1000);
            } else {
                window.location.href = '/'
            }
        }).catch(err => console.log(err));
    }

    useState(() => { checkToken() }, [token]);

    return Helper.ShowLoader();
}

export default ApplicationToken;